export function setTodayTasks(state, data) {
  data.forEach(element => {
    calculeIfDue(element)
  });
  state.todayTasks = data
}

export function setAllTasks(state, data) {
  state.allTasksNEvents = data;
}


export function setTaskPerDate(state, dates) {
  let datesFormat = {};
  dates.forEach(date => {
    date.tasks.forEach(task => calculeIfDue(task));
    datesFormat[date.date] = date;
  });

  state.taskPerDate = removeRepeatedTasks(datesFormat);
}

function removeRepeatedTasks(tasksPerDate) {
  const dateNames = Object.keys(tasksPerDate);
  if (!dateNames.length) return {};
  const allTask = tasksPerDate['month']['tasks'];
  const weekTasks = tasksPerDate['week']['tasks'] || [];
  const todayTasks = tasksPerDate['today']['tasks'] || [];
  if (!allTask?.length) {
    return {};
  } else {
    if (!weekTasks.length) {
      return { month: { tasks: allTask } };
    }
    const allTasksIds = allTask.map(task => task.id);
    const repeatTaks = {
      month: [
        ...weekTasks
          .filter(task => allTasksIds.includes(task.id))
          .map(task => task.id)
      ],
      week: [
        ...todayTasks
          .filter(task => weekTasks.includes(task.id))
          .map(task => task.id)
      ]
    };
    const data = {
      today: todayTasks,
      week: weekTasks.filter(task => !repeatTaks['week'].includes(task.id)),
      month: allTask.filter(task => !repeatTaks['month'].includes(task.id))
    };
    return data;
  }
}

export function cleanErrors(state) {
  state.error = false
  state.errorMessage = ''
}

export function error(state, payload) {
  state.error = true
  state.errorMessage = payload
}

export function setSelectedTaskData(state, payload) {
  if (Object.keys(payload).includes('coins')) {
    state.earnPoints = true
    state.pointsEarned = payload.coins
  } else {
    state.earnPoints = false
  }
  if (Object.keys(payload).includes('data')) {
    state.selectedTask = payload.data
  }
}

export function setNotificationTypes(state, payload) {
  state.notificationsTypes = transformChoicesToDict(payload)
}

export function setRepeatOptions(state, payload) {
  state.RepeatOptions = transformChoicesToDict(payload)
}


function transformChoicesToDict(payload) {
  let response = []
  payload.forEach(element => {
    response.push({ value: element[0], text: element[1] })
  });
  return response
}


export function setPriorities(state, payload) {
  state.Priorities = payload
}

export function setClasses(state, payload) {
  state.Classes = payload
}

export function addNewClass(state, payload) {
  state.Classes.push(payload)
}

export function removeClass(state, id) {
  let index = 0
  let counter = -1
  state.Classes.forEach(element => {
    counter++
    if (element.id == id)
      index = counter
  });
  if (index != -1) {
    state.Classes.splice(index, 1);
  }
}

export function setTypes(state, payload) {
  state.Types = payload
}

export function setProjects(state, payload) {
  state.projects = payload
}

export function setTasktoProjects(state, payload) {
  const projects = state.projects;
  const {id, tasks} = payload;
  state.projects = projects.map((project) => `${project.id}` === `${id}` ? ({...project, tasks}): project)
}

export function setPendingTaks(state, payload) {
  payload.forEach(element => {
    calculeIfDue(element)
  });
  state.pendingTasks = payload
}

function calculeIfDue(element){
  let now = new Date();
  let nowMinute = now.getHours()*60 + now.getMinutes()
  let date = new Date(element.date)
  let taskMinute = date.getHours()*60 + date.getMinutes()
  date = date.setHours(0,0,0,0)
  now = now.setHours(0,0,0,0)
  if (date==now){
    element.is_due=taskMinute<nowMinute
  }
}

export function setTaskUpdated(state, payload) {
  const hasTask = !!state.allTasksNEvents.length;
  const {task, isProject} = payload;
  if(isProject){
    const project = state.projects.find((project) =>`${project.id}` === `${task.project_id}`);
    const tasks = project.tasks.map(_task => _task.id === task.id ? task:_task);
    setTasktoProjects(state, {id: project.id, tasks});
  }
  if(hasTask){
    const tasks = state.allTasksNEvents.map(_task => _task.id === task.id ? task:_task) || [];
    state.allTasksNEvents = tasks;
  }
}
